/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import { connect } from 'react-redux';
import ParticipantDetailsComponent from './participant.details.component';
import { showModal } from '../../actions/actions';
import {
  MODAL_TYPE_EDIT_PARTICIPANT_STATUS,
  MODAL_TYPE_EDIT_PARTICIPANT_DETAILS,
  MODAL_TYPE_EDIT_PARTICIPANT_GENDER,
  MODAL_TYPE_EDIT_PARTICIPANT_BIRTHDATE,
  MODAL_TYPE_EDIT_PARTICIPANT_ADDRESS,
  MODAL_TYPE_EDIT_PARTICIPANT_EMAIL
} from '../../constants/modalTypes';
import {
  CHANGE_PARTICIPANT_JOURNEY_TITLE,
  CHANGE_PARTICIPANT_STATUS_TITLE,
  CHANGE_PARTICIPANT_EMAIL_TITLE,
  CHANGE_PARTICIPANT_GENDER_TITLE,
  CHANGE_PARTICIPANT_BIRTHDATE_TITLE,
  CHANGE_PARTICIPANT_ADDRESS_TITLE
} from '../../const';
import { checkParticipantHasNewVersions } from '../../actions/participant.status.actions';

export const mapStateToProps = (state) => {
  return {
    subjectPhi: state.subject.phi,
    documents: state.documents,
    participantJourney: state.subject.participantJourney,
    participantStudy: state.subject.participantStudy,
    participantSites: state.subject.participantSites,
    isFetchingJourney: state.subject.isFetchingJourney
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    openStatusModal: () => {
      dispatch(
        showModal(MODAL_TYPE_EDIT_PARTICIPANT_STATUS, {
          shouldCloseOnOverlayClick: false,
          title: CHANGE_PARTICIPANT_STATUS_TITLE,
          className: 'participant-status-modal'
        })
      );
    },
    openDetailsModal: () => {
      dispatch(
        showModal(MODAL_TYPE_EDIT_PARTICIPANT_DETAILS, {
          shouldCloseOnOverlayClick: false,
          title: CHANGE_PARTICIPANT_JOURNEY_TITLE,
          className: 'participant-details-modal'
        })
      );
    },
    checkParticipantHasNewVersions: (participantJourneyGid, consentingGid) => {
      dispatch(checkParticipantHasNewVersions(participantJourneyGid, consentingGid));
    },
    openParticipantEmailModal: () => {
      dispatch(
        showModal(MODAL_TYPE_EDIT_PARTICIPANT_EMAIL, {
          shouldCloseOnOverlayClick: false,
          title: CHANGE_PARTICIPANT_EMAIL_TITLE,
          className: 'participant-email-modal'
        })
      );
    },
    openGenderModal: () => {
      dispatch(
        showModal(MODAL_TYPE_EDIT_PARTICIPANT_GENDER, {
          shouldCloseOnOverlayClick: false,
          title: CHANGE_PARTICIPANT_GENDER_TITLE,
          className: 'modal-wrapper participant-gender-modal'
        })
      );
    },
    openBirthDateModal: () => {
      dispatch(
        showModal(MODAL_TYPE_EDIT_PARTICIPANT_BIRTHDATE, {
          shouldCloseOnOverlayClick: false,
          title: CHANGE_PARTICIPANT_BIRTHDATE_TITLE,
          className: 'modal-wrapper participant-birthdate-modal'
        })
      );
    },
    openAddressModal: () => {
      dispatch(
        showModal(MODAL_TYPE_EDIT_PARTICIPANT_ADDRESS, {
          shouldCloseOnOverlayClick: false,
          title: CHANGE_PARTICIPANT_ADDRESS_TITLE,
          className: 'modal-wrapper participant-address-modal'
        })
      );
    }
  };
};

const ParticipantDetailsContainer = connect(mapStateToProps, mapDispatchToProps)(ParticipantDetailsComponent);

export default ParticipantDetailsContainer;
